const messages = {
  title: 'Oops! Hvorfor er du her?',
  description:
    'Vi beklager ulempene. Det ser ut til at du prøver å ' +
    'åpne en side som enten er slettet eller aldri har eksistert.',
  backHomeButton: 'Tilbake til dashbord'
}

export default {
  messages
}
